import { useLaunchParams as useLaunchParamsOriginal } from "@telegram-apps/sdk-react"

export function useLaunchParams() {
	try {
		// biome-ignore lint/correctness/useHookAtTopLevel: Graceful degradation - SDK throws вне Telegram (e2e тесты в браузере)
		return useLaunchParamsOriginal()
	} catch (_error) {
		console.warn("[Telegram] useLaunchParams unavailable, using fallback")
		// Возвращаем минимальный объект совместимый с типом LaunchParams
		return {
			platform: "unknown" as const,
			version: "1.0",
			tgWebAppStartParam: undefined,
			tgWebAppData: undefined,
			tgWebAppPlatform: "unknown",
			tgWebAppVersion: "1.0",
			tgWebAppThemeParams: {},
		}
	}
}
